/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import ContentPanel from 'components/common/ContentPanel';
import Form from 'components/common/Form';
import Text from 'components/common/Text';
import TextLink from 'components/common/TextLink';
import FlexRow from 'components/common/FlexRow';
import { ContentPanelFooter } from 'components/common/ContentPanel';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';

const GoodbyeGroupView = (props) => {
  return (
    <ContentPanel isFixedWidth goBack={props.goBack} titlePhrase={{ id: 'deactivateAccountSuccess.title.text' }}>
      <WhiteCardWithWidePadding>
        <Form>
          <div>
            <Text size="body">
              <FormattedMessage id="deactivateAccountSuccess.successMessage.text" />
            </Text>
          </div>

          <ContentPanelFooter>
            <FlexRow>
              <div />
              <TextLink className="theme-group base color" href={BPH_GROUPS_HOME}>
                <FormattedMessage id="deactivateAccountSuccess.groupsHome.button.label" />
              </TextLink>
            </FlexRow>
          </ContentPanelFooter>
        </Form>
      </WhiteCardWithWidePadding>
    </ContentPanel>
  );
}

export default GoodbyeGroupView;
